export default /* glsl */`
uniform sampler2D tMap;
uniform sampler2D tFocusMap;
uniform vec3 uOutlineColor;
uniform float uOutlineOpacity;

uniform vec3 uOverlayColor;
uniform float uOverlayOpacity;
uniform vec2 uResolution;
varying vec2 vUv;

float edge(sampler2D tex, vec2 uv, vec2 resolution) {
    vec2 texel = vec2( 1.0 / resolution.x, 1.0 / resolution.y );

    const mat3 Gx = mat3( -1, -2, -1, 0, 0, 0, 1, 2, 1 ); // x direction kernel
    const mat3 Gy = mat3( -1, 0, 1, -2, 0, 2, -1, 0, 1 ); // y direction kernel

    // first column
    float tx0y0 = texture2D(tex, uv + texel * vec2( -1, -1 ) ).r;
    float tx0y1 = texture2D(tex, uv + texel * vec2( -1,  0 ) ).r;
    float tx0y2 = texture2D(tex, uv + texel * vec2( -1,  1 ) ).r;

    // second column
    float tx1y0 = texture2D(tex, uv + texel * vec2(  0, -1 ) ).r;
    float tx1y1 = texture2D(tex, uv + texel * vec2(  0,  0 ) ).r;
    float tx1y2 = texture2D(tex, uv + texel * vec2(  0,  1 ) ).r;

    // third column
    float tx2y0 = texture2D(tex, uv + texel * vec2(  1, -1 ) ).r;
    float tx2y1 = texture2D(tex, uv + texel * vec2(  1,  0 ) ).r;
    float tx2y2 = texture2D(tex, uv + texel * vec2(  1,  1 ) ).r;

    // gradient value in x direction
    float valueGx = Gx[0][0] * tx0y0 + Gx[1][0] * tx1y0 + Gx[2][0] * tx2y0 + Gx[0][1] * tx0y1 + Gx[1][1] * tx1y1 + Gx[2][1] * tx2y1 + Gx[0][2] * tx0y2 + Gx[1][2] * tx1y2 + Gx[2][2] * tx2y2;
    float valueGy = Gy[0][0] * tx0y0 + Gy[1][0] * tx1y0 + Gy[2][0] * tx2y0 + Gy[0][1] * tx0y1 + Gy[1][1] * tx1y1 + Gy[2][1] * tx2y1 + Gy[0][2] * tx0y2 + Gy[1][2] * tx1y2 + Gy[2][2] * tx2y2;

    float G = sqrt( ( valueGx * valueGx ) + ( valueGy * valueGy ) );

    return G;
}

vec4 layer(vec4 foreground, vec4 background) {
    return foreground * foreground.a + background * (1.0 - foreground.a);
}

void main() {
    vec4 mapTexel = texture2D(tMap, vUv);

    float e = edge(tFocusMap, vUv, uResolution);

    vec4 outlineTexel = vec4(vec3(e), 1.);
    outlineTexel.rgb *= uOutlineColor;
    outlineTexel.a *= e * uOutlineOpacity;
    
    vec4 overlayTexel = texture2D(tFocusMap, vUv);
    float r = overlayTexel.r;
    overlayTexel.rgb = overlayTexel.rrr * uOverlayColor;
    overlayTexel.a *= r * uOverlayOpacity;

    vec4 outline = layer(overlayTexel, outlineTexel);
    
    gl_FragColor = layer(outline, mapTexel);
}`;
